var __rspack_ns_object = JSON.parse('{"TABS":{"GENERAL":"General","SHOWS":"Shows","FINANCE":"Finance"}}')